export enum ErrorRoutes {
    notFound = 'notFound',
    error = 'error'
}
